import { Decimal } from 'decimal.js'

export const useCalculationUtil = {
  /**
   * 加
   */

  add: (arg1, arg2) => {
    return new Decimal(arg1).add(new Decimal(arg2))
  },

  /**
   * 减
   */
  sub: (arg1, arg2) => {
    return new Decimal(arg1).sub(new Decimal(arg2))
  },

  /**
   * 乘
   */
  mul: (arg1, arg2) => {
    return new Decimal(arg1).mul(new Decimal(arg2))
  },

  /**
   * 除
   */
  div: (arg1, arg2) => {
    return new Decimal(arg1).div(new Decimal(arg2))
  },

  /**
   * 金额转换
   */
  money: (val, precision = 4) => {
    return new Decimal(val || 0).toFixed(precision)
  },

  /**
   * 去掉多余的小数和零
   */
  remove: val => {
    return val ? `${val}`.replace(/(?:\.0*|(\.\d+?)0+)$/, '$1') || '0' : '0'
  }
}
